import type { BusId, WreckContent } from '../content';
import type { GameState } from './types';

export function isDevicePowered(state: GameState, deviceId: string, bus: BusId): boolean {
  return (
    state.power.buses[bus] === 'restored' ||
    (state.power.jumper?.deviceId === deviceId && state.power.jumper.remainingSeconds > 0)
  );
}

export function isConnectionPassable(
  state: GameState,
  content: WreckContent,
  connectionId: string,
): boolean {
  const definition = content.connections.find((connection) => connection.id === connectionId);
  const runtime = state.connections[connectionId];
  if (!definition || !runtime || runtime.collapsed) return false;
  if (definition.bus) {
    return (
      (runtime.open || definition.kind === 'door') &&
      isDevicePowered(state, connectionId, definition.bus)
    );
  }
  return runtime.open;
}

export function areNavigationClampsReleased(state: GameState): boolean {
  return isDevicePowered(state, 'navigation-clamps', 'B');
}
